import { isAutoRentalTile, TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { isCampgroundTile, ISearchResultTile } from '@/utility/mapSearchResultToTile';

export const computeCustomListingTitle = (listingTile: ISearchResultTile | TAutoRentalTile) => {
  if (isAutoRentalTile(listingTile)) {
    return listingTile.details?.year && listingTile.details?.make && listingTile.details?.model
      ? `${listingTile.details.year} ${listingTile.details?.make} ${listingTile.details?.model}`
      : undefined;
  }

  if (isCampgroundTile(listingTile) || listingTile.isStay) {
    return undefined;
  }

  return listingTile.details?.year && listingTile.details?.classText
    ? `${listingTile.details.year} ${listingTile.details.classText}`
    : undefined;
};
